module.exports = __webpack_public_path__ + "img/ui-1.ab6efea8.png";